// extracted by mini-css-extract-plugin
export var button = "Button-module--button--c6eb6";
export var centerAlign = "Button-module--center--align--e7ed6";
export var downBounce = "Button-module--down-bounce--eca10";
export var endAlign = "Button-module--end--align--ad5a0";
export var ghostTheme = "Button-module--ghost--theme--91029";
export var iconArrow = "Button-module--icon-arrow--b93fb";
export var iconArrowDown = "Button-module--icon-arrow-down--aa87f";
export var iconConfigure = "Button-module--icon-configure--e51aa";
export var invertTheme = "Button-module--invert--theme--13f95";
export var lgSize = "Button-module--lg--size--6b880";
export var mdSize = "Button-module--md--size--b7b91";
export var rightBounce = "Button-module--right-bounce--36d2a";
export var smSize = "Button-module--sm--size--cdc97";
export var standardTheme = "Button-module--standard--theme--460dc";
export var startAlign = "Button-module--start--align--70752";
export var stretchAlign = "Button-module--stretch--align--f8f21";